import { Component, h, Prop, State } from "@stencil/core";

import { AdobeAnalyticsTrackingService } from "../../services/tracking/adobe-analytics-tracking.service";

@Component({
  tag: "scs-flipping-card",
  styleUrls: ["flipping-card.scss"],
  shadow: true,
})
export class FlippingCard {
  private adobeAnalyticsTrackingService: AdobeAnalyticsTrackingService;
  @Prop()
  public preTitle = "";
  @Prop()
  public mainTitle = "";
  @Prop()
  public imgSrc = "";
  @Prop()
  public imgSrcDesktop = "";
  @Prop()
  public backsideTitle = "";
  @Prop()
  public backsideText = "";
  @Prop()
  public backsideLink = "";
  @Prop()
  public backsideLinkText = "";
  @Prop()
  public textAlign = "";
  @Prop()
  public gradientDirection = "";
  @Prop()
  public trackingEnabled = true;
  @Prop()
  public trackingLocation = "home";
  @Prop()
  public trackingAction = "link";
  @Prop()
  public trackingCategory = "flipping-card";
  @State()
  public flipped = false;

  private trackByEvent: (event: Event) => void;

  public constructor() {
    this.adobeAnalyticsTrackingService =
      AdobeAnalyticsTrackingService.getInstance();
    this.trackByEvent = this.adobeAnalyticsTrackingService.trackByEvent.bind(
      this.adobeAnalyticsTrackingService,
    );
  }

  isDesktop() {
    return window.innerWidth >= 480;
  }

  public render() {
    return (
      <div class="wrapper">
        <div class={{ card: true, flipped: this.flipped }}>
          <div
            class={{
              frontside: true,
              "gradient-direction-left": this.gradientDirection === "left",
              "gradient-direction-top": this.gradientDirection === "top",
              "gradient-direction-right": this.gradientDirection === "right",
            }}
            data-track-action={this.trackingEnabled && this.trackingAction}
            data-track-location={this.trackingEnabled && this.trackingLocation}
            data-track-label={this.trackingEnabled && "flipping-card-flip"}
            data-track-category={this.trackingEnabled && this.trackingCategory}
            onClick={(ev: Event) => {
              if (this.trackingEnabled) {
                this.trackByEvent(ev);
              }
              this.flipped = true;
            }}
            style={{
              "background-image": `url(${
                this.isDesktop() && this.imgSrcDesktop
                  ? this.imgSrcDesktop
                  : this.imgSrc
              })`,
            }}
          >
            <div class="frontside-gradient">
              <div
                class={{
                  "frontside-content": true,
                  "align-text-bottom": this.textAlign === "bottom",
                }}
              >
                <h3>{this.preTitle}</h3>
                <h2>{this.mainTitle}</h2>
              </div>
              <sdx-button
                class="info-icon-button"
                theme="transparent"
                icon-name="icon-information-circle"
                icon-size="2"
                sr-hint="Info"
              />
            </div>
          </div>
          <div
            class="backside"
            data-track-action={this.trackingEnabled && this.trackingAction}
            data-track-location={this.trackingEnabled && this.trackingLocation}
            data-track-label={
              this.trackingEnabled && "flipping-card-flip-backwards"
            }
            data-track-category={this.trackingEnabled && this.trackingCategory}
            onClick={(ev: Event) => {
              if (!this.backsideLink) {
                if (this.trackingEnabled) {
                  this.trackByEvent(ev);
                }
                this.flipped = false;
              }
            }}
          >
            <div class="unflip-button-wrapper">
              <sdx-button
                class="unflip-button"
                theme="transparent"
                icon-name="icon-clear-circle"
                icon-size="3"
                label=""
                sr-hint="Flip card back"
                data-track-action={this.trackingEnabled && this.trackingAction}
                data-track-location={
                  this.trackingEnabled && this.trackingLocation
                }
                data-track-label={
                  this.trackingEnabled && "flipping-card-flip-backwards"
                }
                data-track-category={
                  this.trackingEnabled && this.trackingCategory
                }
                onClick={(ev: Event) => {
                  if (this.backsideLink) {
                    if (this.trackingEnabled) {
                      this.trackByEvent(ev);
                    }
                    this.flipped = false;
                  }
                }}
              ></sdx-button>
            </div>
            <div class="backside-container">
              <h4>{this.backsideTitle}</h4>
              <p>{this.backsideText}</p>
              {this.backsideLink && (
                <sdx-button
                  theme="transparent"
                  icon-name="icon-arrow-right"
                  icon-size="1"
                  label={this.backsideLinkText || "Show me!"}
                  sr-hint="Open the link"
                  data-track-action={
                    this.trackingEnabled && this.trackingAction
                  }
                  data-track-location={
                    this.trackingEnabled && this.trackingLocation
                  }
                  data-track-label={
                    this.trackingEnabled && "flipping-card-link"
                  }
                  data-track-category={
                    this.trackingEnabled && this.trackingCategory
                  }
                  onClick={(ev: Event) => {
                    if (this.trackingEnabled) {
                      this.trackByEvent(ev);
                    }
                    window.location.href = this.backsideLink;
                  }}
                ></sdx-button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
